/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ModeratorsNotificationsList200Item,
  ModeratorsNotificationsListParams,
  ModeratorsNotificationsMarkAllReadCreate200
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Notifications for the current moderator, most recent first. Paginated; `unreadCount` is the total unread across all pages.
 * @summary List my notifications (moderator)
 */
export const moderatorsNotificationsList = (
    params?: ModeratorsNotificationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorsNotificationsList200Item[]>(
      {url: `/api/v1/moderators/notifications/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsNotificationsListQueryKey = (params?: ModeratorsNotificationsListParams,) => {
    return [`/api/v1/moderators/notifications/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsNotificationsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsNotificationsList>>, TError = unknown>(params?: ModeratorsNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsNotificationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsNotificationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsNotificationsList>>> = ({ signal }) => moderatorsNotificationsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsNotificationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsNotificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsNotificationsList>>>
export type ModeratorsNotificationsListQueryError = unknown

/**
 * @summary List my notifications (moderator)
 */
export const useModeratorsNotificationsList = <TData = Awaited<ReturnType<typeof moderatorsNotificationsList>>, TError = unknown>(
 params?: ModeratorsNotificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsNotificationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsNotificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Mark one of the current moderator's notifications as read.
 * @summary Mark notification as read (moderator)
 */
export const moderatorsNotificationsMarkReadCreate = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/notifications/${id}/markRead/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsNotificationsMarkReadCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsNotificationsMarkReadCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsNotificationsMarkReadCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsNotificationsMarkReadCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsNotificationsMarkReadCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsNotificationsMarkReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsNotificationsMarkReadCreate>>>
    
    export type ModeratorsNotificationsMarkReadCreateMutationError = void

    /**
 * @summary Mark notification as read (moderator)
 */
export const useModeratorsNotificationsMarkReadCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsNotificationsMarkReadCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsNotificationsMarkReadCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsNotificationsMarkReadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Mark every unread notification of the current recipient as read.
 * @summary Mark all my notifications as read (moderator)
 */
export const moderatorsNotificationsMarkAllReadCreate = (
    
 ) => {
      
      
      return customInstance<ModeratorsNotificationsMarkAllReadCreate200>(
      {url: `/api/v1/moderators/notifications/markAllRead/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsNotificationsMarkAllReadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsNotificationsMarkAllReadCreate>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsNotificationsMarkAllReadCreate>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsNotificationsMarkAllReadCreate>>, void> = () => {
          

          return  moderatorsNotificationsMarkAllReadCreate()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsNotificationsMarkAllReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsNotificationsMarkAllReadCreate>>>
    
    export type ModeratorsNotificationsMarkAllReadCreateMutationError = unknown

    /**
 * @summary Mark all my notifications as read (moderator)
 */
export const useModeratorsNotificationsMarkAllReadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsNotificationsMarkAllReadCreate>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsNotificationsMarkAllReadCreate>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getModeratorsNotificationsMarkAllReadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    